export enum OverallReviewResponse {
  THUMBS_UP = 'THUMBS_UP',
  THUMBS_DOWN = 'THUMBS_DOWN',
}

export enum PoorReviewResponseReason {
  INFERENCES = 'INFERENCES',
  MISSING_CONTENT = 'MISSING_CONTENT',
  TOO_COLLOQUIAL = 'TOO_COLLOQUIAL',
  TOO_VERBOSE = 'TOO_VERBOSE',
  INFO_IN_WRONG_SECTION = 'INFO_IN_WRONG_SECTION',
  NOT_MEDICALLY_RELEVANT = 'NOT_MEDICALLY_RELEVANT',
}

export const PoorReviewResponseReasonLabels: Record<PoorReviewResponseReason, string> = {
  INFERENCES: 'Inferences',
  MISSING_CONTENT: 'Missing content',
  TOO_COLLOQUIAL: 'Too colloquial',
  TOO_VERBOSE: 'Too verbose',
  INFO_IN_WRONG_SECTION: 'Info in wrong section',
  NOT_MEDICALLY_RELEVANT: 'Not medically relevant',
};
